import React from 'react';
import { AuthWrapper } from '@src/features/auth/components';
import { ArcButton, ArcStack, ArcText } from '@src/core/ui';
import { routesConfig } from '@src/core/routes';
import { useNavigate } from 'react-router-dom';

const VerifySuccessPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <AuthWrapper>
      <ArcText.h3 textAlign='center'>Check your inbox</ArcText.h3>
      <ArcText.caption mt={1} fontSize={16} textAlign='center'>
            We’ve sent a password reset link to your email.
      </ArcText.caption>
      <ArcText.caption mt={'-3px'} fontSize={16} textAlign='center'>Follow the instructions to create a new password.</ArcText.caption>
      <ArcStack alignItems='center' mt={5}>
        <ArcButton.brand 
          onClick={() => navigate(routesConfig.signIn)}
          sx={{ width: 300}}>
          Back to sign in 
        </ArcButton.brand>
      </ArcStack>

    </AuthWrapper>
  );
};

export default VerifySuccessPage;